import { styled } from '@mui/material/styles';

export const SelectorWrapper = styled('div')(() => ({
  position: 'relative'
}));

export const LanguageSwitch = styled('div')(({ theme }) => ({
  borderRadius: `${theme.borderRadius.base} ${theme.borderRadius.base} 0 0`,
  left: theme.spacing(1),
  overflow: 'hidden',
  position: 'absolute',
  top: 0,
  transform: 'translateY(-100%)'
}));

export const Button = styled('button', {
  shouldForwardProp: prop => prop !== 'active'
})(({ theme, active }) => ({
  backgroundColor: 'inherit',
  border: 'none',
  fontWeight: theme.fontWeight.bold,
  padding: `${theme.spacing(1.75)} ${theme.spacing(3.75)}`,
  textTransform: 'uppercase',
  ...(active
    ? {
        color: theme.color.primary.main,
        background: theme.color.background.surface
      }
    : {
        background: theme.color.background.default
      }),
  '&:focus': {
    outline: 'none'
  }
}));
